<template>
	<transition name="slide-fade">
		<transition-group tag="div" name="streamers">
			<div class="streamers"
			     @scroll="scrollPopup"
			     :key="'main'">
				<transition enter-active-class="animated fadeIn faster"
				            leave-active-class="animated fadeOut faster"
				            :key="'delete'">
					<delete-streamer
						v-show="del"
						:deleteStreamer="deletedStreamer"
						@deleteStreamer="deleteStreamer($event)"
						@cancelDeletePopup="cancelDeletePopup($event)"/>
				</transition>
				<transition enter-active-class="animated fadeIn faster"
				            leave-active-class="animated fadeOut faster"
				            :key="'add'">
					<add-streamer
						v-show="added"
						@cancel="cancelAddStreamer"
						@was_added="wasAdded"/>
				</transition>
				<transition enter-active-class="animated fadeIn faster"
				            leave-active-class="animated fadeOut faster"
				            :key="'update'">
					<update-streamer
						v-show="updated"
						:updatedStreamerHost="updatedStreamer.host"
						:updatedStreamerStr="updatedStreamer.str"
						@cancel="cancelUpdatePopup"/>
				</transition>
				<transition-group tag="div"
				                  class="str_cont"
				                  name="list-complete">
					<div class="list-complete-item"
					     v-for="(streamer, i) in getStreamers"
					     :value="i"
					     :key="i">
						<streamers-item :streamer="streamer"/>
						<div class="button"
						     title="удалить"
						     v-if="getReqUserRole === 'Power User' || getReqUserRole === 'Администратор уровня Бог'"
						     @click="deleteStreamerPopup(streamer.hostname, streamer.operator)">
							<div class="one"></div>
							<div class="two"></div>
						</div>
						<div class="button update"
						     title="редактировать"
						     v-if="getReqUserRole === 'Power User' || getReqUserRole === 'Администратор уровня Бог'"
						     @click="updateStreamer(streamer.hostname, streamer)">
						</div>
					</div>
					<div class="add"
					     @click="addStreamer"
					     v-if="getReqUserRole === 'Power User' || getReqUserRole === 'Администратор уровня Бог'"
					     :key="'add'">
						<div class="button">
							<div class="one"></div>
							<div class="two"></div>
						</div>
					</div>
				</transition-group>
			</div>
		</transition-group>
	</transition>
</template>
<script>
	import StreamersItem                from "./StreamersItem";
	import AddStreamer                  from "./AddStreamer";
	import DeleteStreamer               from "./DeleteStreamer";
	import { performRequest }           from "../script/ws/wsclient";
	import { mapGetters, mapMutations } from "vuex";
	import UpdateStreamer               from "./UpdateStreamer";

	require("animate.css");

	export default {
		name:       "streamers",
		components: { UpdateStreamer, DeleteStreamer, AddStreamer, StreamersItem },
		data() {
			return {
				streamers:       [],
				added:           false,
				del:             false,
				updated:         false,
				currentTarget:   "",
				deletedStreamer: {
					str:  "",
					oper: ""
				},
				updatedStreamer: {
					host: "",
					str:  {}
				}
			};
		},
		beforeMount() {
			// this.streamerCount = this.streamers.length - 1;
			this.getstreamers();
		},
		computed:   {
			...mapGetters(["getStreamers", "getViewUser", "getReqUserRole"])
		},
		methods:    {
			...mapMutations(["setStreamers"]),
			getstreamers() {
				performRequest({
						section: "tvcontent.streamer",
						name:    "getStreamerList"
					},
					{ operator: this.getViewUser },
					a => {
						if (a.code === 200) {
							this.setStreamers(a.data);
						}
					});
			},
			scrollPopup() {
				let elem              = document.querySelector(".streamers");
				let addedPopup        = document.querySelector("#addPopup");
				let deletePopup       = document.querySelector("#deletePopup");
				let updatePopup       = document.querySelector("#updatePopup");
				addedPopup.style.top  = elem.scrollTop + "px";
				deletePopup.style.top = elem.scrollTop + "px";
				updatePopup.style.top = elem.scrollTop + "px";
			},
			wasAdded() {
				this.cancelAddStreamer();
			},
			cancelAddStreamer() {
				this.added           = false;
				document.querySelector(".streamers")
					.style.overflowY = "scroll";
			},
			cancelDeletePopup(e) {
				this.del             = e;
				document.querySelector(".streamers")
					.style.overflowY = "scroll";
			},
			deleteStreamerPopup(streamer, operator) {
				this.deletedStreamer.str  = streamer;
				this.deletedStreamer.oper = operator;
				this.del                  = true;
				document.querySelector(".streamers")
					.style.overflowY      = "hidden";
			},

			deleteStreamer(e) {
				this.del             = e;
				document.querySelector(".streamers")
					.style.overflowY = "scroll";
			},
			addStreamer() {
				this.added           = true;
				document.querySelector(".streamers")
					.style.overflowY = "hidden";
			},
			updateStreamer(host, streamer) {
				this.updated              = true;
				this.updatedStreamer.host = host;
				this.updatedStreamer.str  = streamer;
				document.querySelector(".streamers")
					.style.overflowY      = "hidden";
			},
			cancelUpdatePopup() {
				this.getstreamers();
				this.updated         = false;
				document.querySelector(".streamers")
					.style.overflowY = "scroll";
			}
		},
	};
</script>
<style scoped lang="scss">
	$width_container_button: 24px;
	$width_button_item: $width_container_button - 8;
	$height_button: 2px;
	$height_add: 208px;
	$width_add: $height_add / 4;
	$bd_button: 8px;
	.str_cont {
		display: flex;
		flex-wrap: wrap;
		padding: auto;
	}
	@keyframes test {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}
	.enter {
		animation: test .3s;
		position: absolute;
	}
	.leave {
		animation: test .3s reverse;
		position: absolute;
	}
	.list-complete-item {
		margin: 1rem;
		min-width: 30rem;
		max-width: 60rem;
		transition: all 0.5s ease;
		position: relative;
		flex-grow: 1;
	}
	.streamers {
		background-color: rgba(238, 238, 200, 0.8);
		box-shadow: inset 0 0 5px rgba(51, 51, 51, 0.4), 1px 1px 5px #333;
		height: calc(100vh - 5rem);
		overflow: auto;
		position: absolute;
		margin-top: 4rem;
		width: 90%;
		right: 50%;
		transform: translateX(50%);
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: flex-start;
		align-items: flex-start;
		align-content: flex-start;
		overflow-x: hidden;
		.button {
			position: absolute;
			bottom: 0;
			right: 0;
			background-color: #cc1711;
			border: none;
			outline: none;
			width: $width_container_button;
			height: $width_container_button;
			border-radius: $width_container_button / 2;
			cursor: pointer;
			.one, .two {
				position: absolute;
				width: $width_button_item;
				height: $height_button;
				background-color: #e7ffdd;
				top: ($width_container_button / 2) - ($height_button / 2);
				left: ($width_container_button - $width_button_item) / 2;
				border-radius: 1px;
			}
			.one {
				transform: rotate(45deg);
			}
			.two {
				transform: rotate(-45deg);
			}
		}
		.update {
			background: url(../../static/edit.png) no-repeat center;
			background-size: 80%;
			right: 40px;

		}
		.add {
			height: $height_add;
			width: $width_add;
			margin: 1rem;
			border: $bd_button dashed #afafaf;
			position: relative;
			cursor: pointer;
			transition: all .5s;
			.button {
				background-color: #58ff4a;
				top: ($height_add / 2) - ($width_container_button / 2) - ($bd_button);
				left: ($width_add / 2) - ($width_container_button / 2) - ($bd_button);
				.one {
					background-color: #000;
					transform: rotate(0);
				}
				.two {
					background-color: #000;
					transform: rotate(-90deg);
				}
			}
			&:hover {
				border: $bd_button dashed #766c8e;
			}

		}

	}
	@media (max-width: 620px) {
		.streamers {
			height: calc(100vh - 9rem);
			min-width: 30rem;
			margin-top: 8rem;
			overflow: auto;
		}
	}
	.streamers-enter-active, .streamers-leave-active {
		transition: all 0.5s ease;
	}
	.streamers-enter, .streamers-leave-to {
		opacity: 0;
	}
	.list-complete-enter, .list-complete-leave-to {
		opacity: 0;
		transform: translateX(-50px);
	}
	.list-complete-leave-active {
		position: absolute;
	}
	.slide-fade-enter-active {
		transition: all 0.3s ease;
	}
	.slide-fade-leave-active {
		transition: all 0.3s ease;
	}
	.slide-fade-enter, .slide-fade-leave-to {
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/Streamers.vue